// extracted by mini-css-extract-plugin
module.exports = {"bankQuestionSearch":"BankQuestions_bankQuestionSearch__3PYBS"};